"use client";

import { storyblokEditable } from "@storyblok/react/rsc";
import { motion } from "framer-motion";
import Image from "next/image";
import { Container } from "../layout/container";
import Typography from "../ui/typography";
import { PageHeaderStoryblok } from "@/types/sb-component-types";
interface PageHeaderProps {
  pageHeader?: PageHeaderStoryblok;
}
export const SbPageHeader = ({
  pageHeader
}: PageHeaderProps) => {
  if (!pageHeader) return null;
  return <div className="relative overflow-hidden py-20 pt-40" id="page-header" {...storyblokEditable(pageHeader)} role="banner" data-sentry-component="SbPageHeader" data-sentry-source-file="PageHeader.tsx">
      <div aria-hidden="true" className="absolute inset-0 z-0">
        {pageHeader.backgroundImage?.filename && <Image fill priority alt={pageHeader.backgroundImage?.alt || ""} loading="eager" quality={85} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 70vw" src={pageHeader.backgroundImage.filename} style={{
        objectFit: "cover",
        objectPosition: "center"
      }} />}
        <div aria-hidden="true" className="absolute inset-0 bg-primary/70 mix-blend-multiply" />
      </div>
      <Container className="relative z-20" data-sentry-element="Container" data-sentry-source-file="PageHeader.tsx">
        <motion.div animate={{
        opacity: 1,
        y: 0
      }} initial={{
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.8,
        useReducedMotion: true
      }} data-sentry-element="unknown" data-sentry-source-file="PageHeader.tsx">
          <Typography className="mb-4 text-4xl font-bold text-slate-50 md:text-5xl" variant="h1" data-sentry-element="Typography" data-sentry-source-file="PageHeader.tsx">
            {pageHeader.title}
          </Typography>
          {pageHeader.subtitle && <Typography className="mt-2 max-w-2xl text-lg text-slate-100 md:text-xl" variant="p">
              {pageHeader.subtitle}
            </Typography>}
        </motion.div>
      </Container>
    </div>;
};